export default __webpack_public_path__ + "static/media/task.b2c507ba.svg";